import { ChangeDetectionStrategy, Component, HostBinding, HostListener, computed, input } from '@angular/core';

import { BetSlipType } from '@bpos';
import { EpcotConfig, MyBetsConfig, Sitecore, SitecoreMyBetsConfig } from '@frontend/sports/common/client-config-data-access';
import { RedirectHelperService } from '@frontend/sports/navigation/core/feature/redirect';
import { MarketUrlParam } from '@frontend/sports/navigation/core/feature/url-helper';
import { TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';
import { BetslipListType } from '@frontend/sports/types/models/my-bets';

import { MyBetsBet, MyBetsBetSlip, MyBetsListContext } from '../../../my-bets-base/models/my-bets-viewmodels';
import { MyBetsEventModel } from '../../models/my-bets-event.model';
import { MyBetsUtilService } from '../../services/my-bets-util.service';
import { MyBetsTrackingService } from '../../services/mybets-tracking.service';
import { MyBetsTextBadgeModel } from '../badges/my-bets-text-badge.component';

@Component({
    selector: 'ms-my-bets-betslip-event-info',
    templateUrl: 'my-bets-betslip-event-info.component.html',
    styleUrl: './my-bets-betslip-event-info.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class MyBetsBetslipEventInfoComponent {
    bet = input.required<MyBetsBet>();
    mybetsTextBadgeModel = MyBetsTextBadgeModel;
    event = input.required<MyBetsEventModel>();
    myBetsListContext = input.required<MyBetsListContext>();
    betslip = input.required<MyBetsBetSlip>();
    shouldApplyPaddings = input(false);
    cashedOut = input(false);
    cancelledBet = input(false);
    @HostBinding('class') className = 'mybets-betslip-info mybets-betslip-event-info';

    isEpcotEnabled = false;

    isGridScoreboardEnabled = computed(() => this.myBetsUtilService.isGridScoreboardEnabled(this.event()));
    showBetslipId = computed(() => this.myBetsListContext().isPrintView && this.betslip()?.betType === BetSlipType.Single);

    constructor(
        private redirectHelper: RedirectHelperService,
        private tracker: TrackingService,
        public siteCore: Sitecore,
        public sitecoreMyBets: SitecoreMyBetsConfig,
        public mybetsConfig: MyBetsConfig,
        private epcotConfig: EpcotConfig,
        public myBetsUtilService: MyBetsUtilService,
        private myBetsTrackingService: MyBetsTrackingService,
    ) {
        this.isEpcotEnabled = this.epcotConfig.isEnabled;
    }

    @HostListener('click')
    handleEventClick(): void {
        if (this.myBetsListContext().listType !== BetslipListType.Settled && !this.bet().isVirtual) {
            this.tracker.track(trackingConstants.EVENT_PAGE_VIEW, {
                [trackingConstants.PAGE_NAME]: 'Event' + (this.myBetsListContext().isEventView ? '_EventView' : '_myBets'),
                [trackingConstants.PAGE_SITE_SECTION]: this.myBetsListContext().isEventView ? 'eventView' : 'myBets',
                eventId: this.event().id,
            });
            const routeAbsPath = this.myBetsTrackingService.getRoutePath(this.event(), MarketUrlParam.MyBets);
            this.redirectHelper.goToPage(routeAbsPath);
            this.myBetsTrackingService.trackMyBetsScoreboard(routeAbsPath, this.myBetsListContext().listType);
        }
    }
}
